/**
 * @generated SignedSource<<750e5f8e1581492b9f529f267dc1270b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AuthGuard_data$data = {
  readonly viewer: {
    readonly name: string;
  } | null;
  readonly " $fragmentType": "AuthGuard_data";
};
export type AuthGuard_data$key = {
  readonly " $data"?: AuthGuard_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"AuthGuard_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AuthGuard_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "viewer",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "356826bf454150451d6b118a2938accb";

export default node;
